import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';

import get from 'lodash/get';

import {
  loadCampaign,
  syncCampaignGeoFilter,
  syncCampaignResponseFilter,
  loadActiveUser,
  targetCampaign
} from '../../shared/redux/entities/actions';

import {
  loadKPIsForCampaign
} from '../../shared/redux/kpis/actions';

import {
  loadListOfStatesAndDMAs,
  loadListOfConstraintsForAgency
} from '../../shared/redux/audience/actions';
import {getActiveUser} from "../../shared/redux/selectors";


function mapStateToProps(state,props){
  const campaignId = props.match.params.campaignId,
    agencyId = get(state,['entities','campaigns',campaignId,'agencyId'],null);
  const activeUser = getActiveUser(state);

  return {
    activeUser:activeUser,
    geofilters:state.audience.geofilters,
    campaignId:campaignId,
    agencyId:agencyId,
    activeCampaignGeoFilterPredicate:get(state,['entities','campaigns',campaignId,'geoFilterPredicate'],null),
    activeCampaignFilters:get(state,['entities','campaigns',campaignId,'filters'],[]),
    activeCampaignConstraints:get(state,['entities','campaigns',campaignId,'constraints'],[]),
    campaignFilters:(state.audience.responseConstraints || []).filter((r) => r.agencyId === agencyId && r.name.length > 0),
    engagementFilters:[],
    campaignKpis:Object.values(state.kpis.campaigns)
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to GuidedCampaignAudience
  return bindActionCreators({
    loadListOfStatesAndDMAs,
    loadListOfConstraintsForAgency,
    loadCampaign,
    loadKPIsForCampaign,
    syncCampaignGeoFilter,
    syncCampaignResponseFilter,
    targetCampaign
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignAudience/connect.js